import ActionType from 'actions/ActionType'

export default (state = false, action) => {
  switch (action.type) {
    case ActionType.Inbox.TOGGLE_THREAD_VIEW:
      return typeof action.payload === 'boolean' ? action.payload : !state
    case ActionType.Inbox.SELECT_CONVERSATION:
      return Boolean(action.payload)
    case ActionType.Inbox.CONTACT_SEARCH:
      if (action.payload === null) return false
      return true
    default:
      return state
  }
}
